import React from "react";
import {ChronoUnitLegacy, dateBody} from "utils/time-utils";

export const CombinedColumnRows = (row1: React.ReactElement, row2: React.ReactElement): React.ReactElement => {
    const children1 = React.Children.toArray(row1.props.children);
    const children2 = React.Children.toArray(row2.props.children);

    const combinedChildren = [...children1, ...children2];

    return React.cloneElement(row1, {children: combinedChildren});
};

export const StyledRows = (combinedRows: React.ReactElement[]): React.ReactElement[] => {
    const totalRows = combinedRows.length;

    return combinedRows.map((row, rowIndex) => {
        const newChildren = React.Children.map(row.props.children, (child) => {
            const childElement = child as React.ReactElement;
            if (childElement.key && childElement.key.includes("DATASET")) {
                const rowSpan = totalRows - rowIndex;
                return React.cloneElement(childElement, { rowSpan });
            }
            // Check if the key is "date" and set the rowSpan
            if (childElement.key === "date") {
                return React.cloneElement(childElement, { rowSpan: totalRows });
            }
            return child;
        });

        return React.cloneElement(row, { children: newChildren });
    });
};

export const findHighlightRange = (value: number, highlightRanges: any[]) => {
    return highlightRanges.find(range => {
        const minCondition = range.min.inclusive ? value >= range.min.value : value > range.min.value;
        const maxCondition = range.max.inclusive ? value <= range.max.value : value < range.max.value;
        return minCondition && maxCondition;
    });
};

export const calculateColSpan = (datasets: any[]): number => {
    let count = 0;
    datasets.forEach((dataset) => {
        if (dataset.children) {
            count += calculateColSpan(dataset.children);
        } else {
            count += 1;
        }
    });
    return count;
};

export const WIDTH_LOOKUP_TABLE: Record<ChronoUnitLegacy, string> = {
    "YEARS": "45px",
    "MONTHS": "60px",
    "WEEKS": "70px",
    "DAYS": "80px",
    "HOURS": "95px",
    "MINUTES": "115px",
    "SECONDS": "130px"
};

export const getRowData = (data: any[], datasets: any[], dateFormat: ChronoUnitLegacy) => {
    return data.map(row => {
        const newRow = {...row};
        newRow.Date = dateBody(row.date as string, dateFormat);
        delete newRow.date;

        // Iterate over keys in the row
        for (let key in newRow) {
            // If the value is an empty string, replace it with "-"
            if (newRow[key] === "") {
                newRow[key] = "-";
            } else {
                const dataset = datasets.find(dataset => dataset.identifier === key);
                if (dataset) {
                    if (typeof newRow[key] === "number") {
                        let temp = newRow[key] as number;
                        newRow[key] = temp.toFixed(dataset.decimalPlaces)
                    }
                }
            }
        }

        return newRow;
    });
}
